module.exports = __webpack_public_path__ + "img/1783506547640511.6e46d863.webp";